<template>
	<nav v-if="user && showMenu">
		<router-link to="/">
			<uiLogo />
		</router-link>

		<div class="links">
			<router-link
				v-for="(route, i) in routes"
				:key="i"
				:class="{ selected: isSelected(route) }"
				:to="{ path: route.path }"
			>
				{{ route.meta.title }}
			</router-link>
		</div>

		<div class="user">
			{{ user.name }} |
			<router-link to="/logout">Выйти</router-link>
		</div>
	</nav>
</template>

<script>
import uiLogo from '@/components/ui/uiLogo'
import { routes } from '@/router'
import { intersection } from 'lodash'

export default {
	name: 'Navigation',
	components: {
		uiLogo,
	},
	props: {
		saving: Boolean,
	},
	computed: {
		routes() {
			return routes
				.filter(r => r.meta && r.meta.title)
				.filter(r => {
					let intersect = intersection(this.user.roles, r.meta.roles)
					return intersect.length > 0
				})
		},
		user() {
			return this.$store.getters.user
		},
		showMenu() {
			return this.$route.name !== 'auth' && this.$route.name !== 'logout'
		},
	},
	methods: {
		isSelected(route) {
			return this.$route.fullPath.includes(route.name)
		},
	},
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

nav {
	width: calc(100% - 40px);
	height: 30px;
	padding: 10px 20px;
	display: flex;
	align-items: center;
	position: fixed;
	top: 0;
	left: 0;
	background: @bg;
	z-index: 10;

	.logo {
		width: 30px;
		height: 30px;

		.saving {
			animation: loading 500ms linear infinite;
		}
	}

	.links a {
		text-decoration: none;
		padding-left: 30px;
	}

	a.selected {
		color: #000;
	}

	.user {
		margin-left: auto;

		a {
			cursor: pointer;
		}
	}
}

@keyframes loading {
	0% {
		fill: @red;
	}
	50% {
		fill: @accent;
	}
	100% {
		fill: @yellow;
	}
}
</style>
